// Chinese project translations keyed by project id (fallback: English in portfolio.js)
export const PROJECTS_ZH = {
  "nerget-integration": {
    title: "LG U+ Nerget BSS 集成",
    category: "电信 BSS",
    description: "将 Compax Digital 企业 BSS 平台与 LG U+ Nerget 系统集成 — 使用 Java Spring（JSF 与 Hibernate JPA）和 PostgreSQL 处理两平台间的用户管理、计费和服务开通流程。",
    challenge: "LG U+ Nerget 平台与 Compax 企业 BSS 各自独立管理用户和计费数据，需要一个健壮的集成层，在无需人工对账的情况下同步账户、服务和账单。",
    approach: "使用 Java Spring 构建集成层，配备 JSF 前端界面和基于 PostgreSQL 的 Hibernate JPA 持久层，将 Nerget 数据模型映射到 Compax BSS 实体，并在 LG U+ 预生产环境中端到端验证用户、计费和开通流程。",
    outcome: "集成上线连接了 Compax BSS 与 Nerget，实现用户管理和计费数据在两个平台间的自动化流转。",
  },
  "starhub-integration": {
    title: "StarHub BSS 集成",
    category: "电信 BSS",
    description: "将 Compax Digital 企业 BSS 平台与新加坡 StarHub 电信系统集成，使用 Java Spring（JSF 与 Hibernate JPA）和 PostgreSQL 交付用户、计费和服务管理流程。",
    challenge: "新加坡主要电信运营商 StarHub 需要 Compax BSS 平台在用户入网、计费周期和服务开通方面与其内部电信系统互操作，并有严格的数据一致性要求。",
    approach: "使用 Java Spring 开发集成服务，配备 JSF 界面层和基于 PostgreSQL 的 Hibernate JPA，与 StarHub 工程团队通过联合测试周期紧密协作，认证每一个集成流程。",
    outcome: "按计划成功交付 StarHub 集成，将 Compax BSS 的版图扩展至东南亚电信市场。",
  },
  hiddentag: {
    title: "HiddenTag 全球平台",
    category: "区块链与安全",
    description: "为提供认证、社区、评论和市场服务的全球平台设计后端架构。构建 RESTful API 和数据层，并将部署从 Tomcat 迁移至 AWS 上的 Docker 容器以实现生产上线。",
    challenge: "HiddenTag 需要一个单一的全球后端来服务四个不同的产品领域——认证、社区、评论和市场，而运行在旧版 Tomcat 基础设施上使发布缓慢且充满风险。",
    approach: "使用 Spring Boot 从零设计后端架构，分离领域服务并提供清晰的 RESTful API。使用 Hibernate JPA 和 MyBatis 在 MySQL 上构建数据层，然后将整个部署容器化到 AWS 的 Docker 上以替代 Tomcat 服务器。",
    outcome: "HiddenTag 全球平台按计划上线生产，容器化的部署流水线使后续发布更快且可安全回滚。",
  },
  "sehati-bahrain": {
    title: "SEHATI — 巴林国家健康保险系统",
    category: "国家医疗",
    description: "在 AWS 上完成 SEHATI 巴林国家健康保险系统现代化 — 为巴林王国的国家健康保险平台升级 JDK 7 → 8、Tomcat 7 → 9、Oracle RDS 12c → 19c。",
    challenge: "巴林国家健康保险系统运行在陈旧的基础设施上——JDK 7、Tomcat 7 和 Oracle 12c——为服务全国的平台积累了安全漏洞和维护风险。当 AWS 宣布强制升级所有旧版 Oracle 数据库时，紧迫性陡增：我们 LG CNS 的经理意识到，不受控的 AWS 强制升级可能破坏与生产系统的兼容性，导致全国性故障。此外，遗留栈还存在需要解决的已知安全漏洞。",
    approach: "我们没有被 AWS 的强制升级时间表牵着走，而是掌握主动：在完整测试生产负载兼容性的前提下，规划并执行了 Oracle RDS 12c → 19c 的分阶段迁移，并在同一项目中完成了 JDK 7 → 8 和 Tomcat 7 → 9 升级。JavaScript 到 jQuery 的前端现代化虽已划定范围但被有意推迟——它需要更多开发时间和规划，而 Oracle 数据库才是推动时间线的关键问题。",
    outcome: "SEHATI 在 AWS 强制升级之前零停机迁移至 Oracle 19c、JDK 8 和 Tomcat 9。国家健康保险系统如今运行在其核心栈受支持且安全的版本上，前端现代化则作为单独的后续项目妥善规划。",
  },
  gspostbox: {
    title: "新一代 GS Postbox 系统",
    category: "物流与云",
    description: "为新一代 GS Postbox 平台在 GitOps / ArgoCD Kubernetes 环境中构建 CI/CD 流水线和自动化部署。",
    challenge: "新一代 GS Postbox 系统需要在各环境中频繁、可靠地发布，但部署是手动的、易出错且难以审计。",
    approach: "在 Kubernetes 上设计基于 ArgoCD 的 GitOps CI/CD 流水线，使 Git 成为每个环境的唯一事实来源，并自动化从提交到集群的发布。",
    outcome: "部署实现了完全自动化和可审计，具备声明式回滚和跨交付流水线的一致环境。",
  },
  lguplus: {
    title: "LG U+ 数字目录系统",
    category: "电信系统",
    description: "通过自定义 Maven 配置文件，为基于 Adobe AEM 框架的 LG U+ 数字目录系统构建 Jenkins CI/CD 流水线和自动化部署。",
    challenge: "LG U+ 数字目录运行在 Adobe AEM 上，发布涉及大量手动打包步骤，拖慢了电信产品更新。",
    approach: "构建基于 Jenkins 的 CI/CD 流水线，并为 AEM 框架量身定制自定义 Maven 配置文件，实现各环境的构建、打包和部署自动化。",
    outcome: "目录发布实现端到端自动化，减少了部署工作量，使内容和产品更新更快到达生产环境。",
  },
  shinhanbank: {
    title: "新韩银行 — The Next Project",
    category: "核心银行",
    description: "为新韩银行新一代内部管理系统管理并部署接口服务（MCI / FEP / EAI 服务网格）。",
    challenge: "新韩银行新一代内部系统依赖于错综复杂的系统间接口（MCI / FEP / EAI）网络，任何配置错误都可能中断核心银行业务运营。",
    approach: "管理并部署跨环境的接口服务网格，协调发布并验证银行内部系统间的消息流。",
    outcome: "接口服务在整个项目期间稳定部署和运行，保持了关键任务内部银行系统的互联互通。",
  },
  "korean-social-security": {
    title: "韩国社会保障信息系统",
    category: "公共部门",
    description: "为新一代韩国社会保障信息系统开发基于 MyBatis 的 Java Batch 服务。",
    challenge: "国家社会保障系统需要在预定的批处理窗口内处理海量福利和资格数据，且不容许任何失败。",
    approach: "使用 MyBatis 开发 Java Batch 服务，构建可重启的作业结构，并对系统的大型关系模式进行精确的数据映射。",
    outcome: "为新一代系统交付了批处理服务，在规定窗口内可靠地处理全国社会保障数据。",
  },
  middleblock: {
    title: "Middleblock 区块链平台",
    category: "区块链",
    description: "为 Middleblock 区块链平台（Hyperledger Indy、Aries 与 Fabric）开发 Java Spring 集成 REST API 网关服务器，便于客户应用集成。",
    challenge: "Middleblock 平台（Hyperledger Indy、Aries 与 Fabric）功能强大，但由于区块链 API 复杂，客户应用难以直接集成。",
    approach: "设计并开发了一个 Java Spring 集成 REST API 网关，将三个 Hyperledger 框架封装在单一、简洁的 HTTP 接口之后。",
    outcome: "客户应用可以通过熟悉的 REST 调用接入区块链平台，大幅降低了集成工作量。",
  },
  "yeosu-flagship": {
    title: "丽水数据旗舰项目",
    category: "大数据与智慧城市",
    description: "与 McKinley Rice 国际工程团队协作，设计并实现大数据仓库基础设施和监控平台。",
    challenge: "丽水数据旗舰项目需要聚合和分析城市级数据流，但缺乏支持它的仓库基础设施和可视化平台。",
    approach: "基于 Hadoop、Spark 和 Hive 设计并实现大数据仓库，并使用 Django 后端和 React 前端构建监控平台，与 McKinley Rice 国际工程团队协作完成。",
    outcome: "仓库和监控平台作为丽水智慧城市数据计划的旗舰基础设施交付使用。",
  },
  "sensor-gateway": {
    title: "传感器网关后端迁移",
    category: "IoT 网关",
    description: "将主传感器网关后端从 Go 迁移至 Java Spring（TCP/IP socket、gRPC、REST API），并实现基于 Kafka 的数据管道以提升可靠性和可扩展性。",
    challenge: "核心传感器网关使用 Go 编写，组织难以维护和扩展，且传感器数据管道缺乏持久性保障。",
    approach: "使用 Java Spring 重写网关，支持 TCP/IP socket、gRPC 和 REST API 采集，并实现基于 Kafka 的管道，随后使用 Apache Nifi 和 Streamsets 升级为托管数据流。",
    outcome: "迁移后的网关提升了数据可靠性和可扩展性，同时使代码库与团队的 Java 专长保持一致。",
  },
  "goseong-sacheon": {
    title: "高城与泗川 IoT 仪表盘",
    category: "智慧城市",
    description: "为高城和泗川市政府开发旅游传感器 IoT 仪表盘，提供实时遥测可视化。",
    challenge: "高城和泗川市政府部署了旅游传感器，但无法查看和利用所收集的数据。",
    approach: "使用 React 前端、Java Spring 后端和 MariaDB 存储开发全栈仪表盘，为城市管理者可视化实时旅游传感器遥测数据。",
    outcome: "两个市政府获得了旅游流量和传感器健康状况的实时视图，将原始 IoT 数据转化为可用洞察。",
  },
  "micube-ai": {
    title: "MICUBE AI 可视化工具",
    category: "AI 分析",
    description: "为 KISA 政府项目开发 AI 可视化仪表盘，提供实时分析和图表功能。",
    challenge: "KISA 需要一种方式，让非技术背景的政府利益相关者理解 AI 模型输出和安全分析结果。",
    approach: "使用 Java Spring 后端、Angular 前端和基于 Python 的分析技术开发 AI 可视化工具仪表盘，通过交互式图表呈现模型结果。",
    outcome: "仪表盘交付于 KISA 政府项目，使利益相关者能够直接查看 AI 驱动的分析结果。",
  },
  "daeduk-pd": {
    title: "大德预测性维护引擎",
    category: "智能工厂与 ML",
    description: "为大德电子构建预测性设备维护平台：振动传感器采集机器噪音，Hortonworks 大数据平台存储和处理数据，TensorFlow RMSE 模型检测异常振动，并向工厂仪表盘推送实时警报。",
    challenge: "大德电子需要在工厂车间进行设备故障预测分析——意外的机器故障导致计划外停机和昂贵的紧急维修，而且没有机器正在走向故障的早期预警信号。",
    approach: "将振动传感器安装在设备上持续采集运行噪音，流式传输至 Hortonworks 大数据平台进行存储和处理。我使用 Java Spring 和 Angular 前端构建应用，训练 TensorFlow RMSE 模型学习每台机器的正常振动特征，并标记任何偏离正常运行均值的声音。",
    outcome: "当振动偏离正常均值时，系统会标记异常并实时向工厂仪表盘推送警报——车间员工看到预警后即可在故障前安排维护，使大德电子从被动维修转向预测性维护。",
  },
  "hyundai-cv": {
    title: "现代计算机视觉岩石检测",
    category: "计算机视觉",
    description: "为忠州食物垃圾生物能源中心（충주 음식물 바이오에너지센터）—— 一座由现代建设运营的、每日将 80 吨食物垃圾转化为生物甲烷燃料的设施 —— 使用 TensorFlow Mask R-CNN 模型开发计算机视觉岩石检测应用。",
    challenge: "由现代建设建造的忠州食物垃圾生物能源中心（每日将 80 吨食物垃圾转化为车用燃料和城市燃气的生物甲烷）需要在处理区域自动检测岩石和杂物，而人工检查既缓慢又不稳定。",
    approach: "使用 Java Spring、Angular 和 Python 开发计算机视觉应用，训练 TensorFlow Mask R-CNN 模型对摄像头画面中的岩石进行像素级分割。",
    outcome: "系统实现了生物中心岩石检测的自动化，通过应用深度学习提高了安全性和检查一致性。",
  },
};
